// extracted by mini-css-extract-plugin
export default {"wrapper":"createSpaceModal_wrapper__2Rms+","formControl":"createSpaceModal_formControl__uqVGx","action":"createSpaceModal_action__lCaYP","details":"createSpaceModal_details__bfmw5"};